import React from 'react';
/**
 * Brand logo — always links to the site root.
 */
export function Logo() {
  return <div className="flex-shrink-0 flex items-center" data-id="element-88">
      <a href="/" className="flex items-center" data-id="element-89">
        <img src="https://cdn.magicpatterns.com/uploads/m5AwQ7uZJXzvkVwSXn43Dr/logo.png" alt="TKDScore.com Logo" className="block h-10 w-auto" data-id="element-90" />
      </a>
    </div>;
}